<ngx-monaco-editor [options]="editorOptions"
      [(ngModel)]="data.text"></ngx-monaco-editor>
